import {
  Component,
  ViewChild,
  ComponentFactoryResolver,
  AfterContentInit,
  ElementRef
} from '@angular/core';
import { OnDestroy, OnInit } from '@angular/core';
import { CompanyDTO, CompanyFilterDTO, ActionDefinitionDTO, ActionParameterDefinitionDTO, CompanyProjectDTO, ResultTypeDTO } from '../api/plyca-dtos-v2';
import { ActionDTO } from '../api/plyca-dtos';
import { UIService } from '../ui.service';
import { PlycaDataService } from '../../services/plyca.service';
import { Configuration } from '../conf/app.constants';
import { TranslateService } from '@ngx-translate/core';
import { ServiceLocator } from '../ServiceLocator';
import { PaginationInfo, PaginationDTO } from '../api/PaginationModel';

import { FieldConfig } from '../api/contract-notice-dto';
import { Router } from '@angular/router';
import { CompanyAdminComponent, ViewDTOModal } from './companyAdmin.component';
import { CompanyService } from './company.service';
import { HelpService, HelpType } from '../components/common/help/help.service';
import { HeaderActionsService } from '../components/common/sub-header/header-actions.service';
import { WaitLoadingService } from '../components/common/waitLoading/wait-loading.service';
import { ActionsProcessComponent } from '../actions/actions.process.component';
import { ActionService } from '../actions/action.service';
import { AppConfiguration } from '../conf/app.configuration';
import { BaseComponent } from '../components/common/baseComponent/base.component';
import { UserService } from '../user.service';
import { PlycaErrorHandler } from '../../http/PlycaErrorHandler';
import { DialogService, DynamicDialogConfig } from 'primeng-lts/dynamicdialog';
import { searchGenericComponent, SearchSettingDTOModal } from '../components/search/searchGeneric.component';
import { catchError } from 'rxjs/internal/operators/catchError';
import { throwError } from 'rxjs/internal/observable/throwError';
import { finalize, map, tap } from 'rxjs/operators';
import { MenuItem } from 'primeng-lts/api';
import { forkJoin, of } from 'rxjs';
import { PropertyService } from '../properties/property.service';
import { CompanyProjectComponent } from '../ril/companyproject.component';


@Component({
  selector: 'plyca-companyList',
  templateUrl: 'companyList.template.html',
  providers: [DialogService, UIService, CompanyService]
})
export class CompanyListComponent extends BaseComponent implements AfterContentInit, OnDestroy, OnInit {
  translate: TranslateService;
  locale: string;
  loaded = false;
  selected: CompanyDTO;
  companyProjectSelected: CompanyProjectDTO;
  companyList: CompanyDTO[] = [];
  filters: CompanyFilterDTO;
  editing = false;
  search = '';
  pageInfo: PaginationInfo;
  @ViewChild('dt')
  table: any;
  public PARAM_TAXIDENTIFIER = 'taxIdentifier';
  public PARAM_NAME = 'name';
  public PARAM_RIL = 'ril';
  actions: ActionDefinitionDTO[];
  enableActions = false;
  private actionService: ActionService;
  private userService: UserService;
  userCanEdit = true;
  userCanEditRIL = false;
  private properties = {};



  constructor(
    protected appConfig: AppConfiguration,
    public uiService: UIService,
    protected componentFactoryResolver: ComponentFactoryResolver,
    protected plycaService: PlycaDataService,
    public dialogService: DialogService,
    private headerActionsService: HeaderActionsService,
    private router: Router,
    public companyService: CompanyService,
    public helpService: HelpService,
    private elem: ElementRef,
    private waitService: WaitLoadingService,
    private plycaErrorHandler: PlycaErrorHandler,
    protected configuration: Configuration,
    private propertyService: PropertyService,
  ) {
    super();
    this.translate = ServiceLocator.injector.get(TranslateService);
    this.locale = this.translate.currentLang;
    this.actionService = ServiceLocator.injector.get(ActionService);
    this.userService = ServiceLocator.injector.get(UserService);
    this.subscribe(this.helpService.showContextHelpObservable(HelpType.HELP_COMPANY));
    this.initPageValues();

    let profile = this.appConfig.getValue('controlPanel.company.edition.profiles');
    if (profile) {
      this.userCanEdit = this.userService.hasRoles(profile);
    }

    let profileRil = this.appConfig.getValue('controlPanel.company.riledition.profiles');
    if (profileRil) {
      this.userCanEditRIL = this.userService.hasRoles(profileRil);
    }





  }

  ngOnInit(): void {
    this.waitService.startWaiting();
    this.subscribe(
      forkJoin([
        this.propertyService.getProperty('SincronizacionTerceros.FraMtoEmpresa.PublicarAlEliminarTercero.Activo', '0')
          .pipe(catchError((error: any) => {
            console.log(error)
            return of(undefined)
          })),
        this.propertyService.getProperty('SincronizacionTerceros.Activo', '0')
          .pipe(catchError((error: any) => {
            console.log(error)
            return of(undefined)
          }))
      ]).pipe(
        map(
          (prop: any[]) => {
            this.properties['SincronizacionTerceros_FraMtoEmpresa_PublicarAlEliminarTercero_Activo'] = prop[0] == '1';
            this.properties['SincronizacionTerceros_Activo'] = prop[1] == '1';
          }),
        finalize(() => {

        })
      )
    )
  }

  /*ngOnInit(): void {
    this.waitService.startWaiting();
  }*/

  initPageValues(): void {
    this.pageInfo = new PaginationInfo();
    this.pageInfo.size = 25;
    this.pageInfo.number = 0;
  }

  ngAfterContentInit(): void {
    this.loadConfig();
    this.filters = new CompanyFilterDTO();
    this.load();
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
    this.dialogService = null;
  }

  loadConfig(): void {
    this.enableActions = this.appConfig.getValue('import.company');
    if (this.enableActions) {
      this.subscribe(this.plycaService.getAction('IMPORT_COMPANY'),
        (datos: any) => {
          this.actions = null;
          if (datos && datos.content) {
            this.actions = datos.content;
            this.enableActions = true;
          }
          this.loadHeaders();
        });
    } else {
      this.loadHeaders();
    }
  }
  loadHeaders(): void {
    if (this.appConfig.getValue('companyAdmin.adapt.add.leganes')) {
      this.headerActionsService.setTaskDescription(this.elem, 'CompanyList.title', 'far fa-credit-card', true);
      this.subscribe(this.headerActionsService
        .addAction('ExpedienteRIL', 'fas fa-check', 'btn-primary', true)
        , (() => {
          //this.validateProject();
        }));
      this.headerActionsService.addDivider();
      this.subscribe(this.headerActionsService.addAction(
        'CompanyList.create',
        'fas fa-plus',
        'btn-secondary',
        true
      ),
        success => {
          this.addCompanyLeganes();
        });

    }

    if (this.appConfig.getValue('companyAdmin.integration.importar')) {
      this.headerActionsService.setTaskDescription(this.elem, 'CompanyList.title', 'far fa-credit-card', true);
      this.headerActionsService.addDivider();
      this.subscribe(this.headerActionsService.addAction(
        this.translate.instant('CompanyList.actions.integrationImportar'),
        'fas fa-file-import',
        'btn-secondary',
        true
      ),
        success => {
          this.searchCompanyIntegration();
        });
    }

    if (this.appConfig.getValue('companyAdmin.add')) {
      this.headerActionsService.setTaskDescription(this.elem, 'CompanyList.title', 'far fa-credit-card', true);
      this.headerActionsService.addDivider();
      this.subscribe(this.headerActionsService.addAction(
        'CompanyList.create',
        'fas fa-plus',
        'btn-secondary',
        true
      ),
        success => {
          this.addCompany();
        });
    }
    if (this.enableActions) {

      this.actions.forEach(action => {

        this.subscribe(this.headerActionsService.addAction(
          action.name,
          this.actionService.getActionIconClass(action.executableAction),
          'btn-secondary',
          true
        ),
          success => {
            this.subscribe(this.openModal(action.executableAction).onClose,
              () => this.load());
          });
      });


    }

    this.headerActionsService.addDivider();

    this.subscribe(this.headerActionsService.addAction(
      'General.back',
      'fas fa-chevron-left',
      'btn-outline-secondary',
      true
    ),
      success => {
        this.uiService.routeBack();
      });

  }

  openModal(action: ActionDTO) {

    let config: DynamicDialogConfig = {
      header: action.name,

      width: '70%',
      styleClass: 'actionStyle'

    };
    config['action'] = action;
    //config['obj'] = obj;

    return this.dialogService.open(ActionsProcessComponent, config);


  }

  reloadCompanies(event: any) {
    this.pageInfo.number = event.page;
    this.pageInfo.size = event.rows;
    this.load();
  }

  searchCompanyIntegration() {
    let parametersURL: ActionParameterDefinitionDTO[] = [];
    let completedResult = true;
    let autoSearch = false;
    let contextSearch = new SearchSettingDTOModal(
      'IntegrationCompanySearch',
      autoSearch,
      parametersURL,
      completedResult
      //,searchConfig
    );
    let config: DynamicDialogConfig = {
      header: '',
      width: '70%',
      style: { overflow: 'scroll', 'max-height': '80%' }
    };
    config['context'] = contextSearch;

    const ref = this.dialogService.open(searchGenericComponent, config);

    this.subscribe(ref.onClose.pipe(
      tap((newCompany: CompanyDTO) => {
        if (newCompany) {
          this.subscribe(
            this.plycaService.query<CompanyDTO>(
              this.configuration.COMPANY_SERVICE_URL,
              {
                taxIdentifier: newCompany.taxIdentifier
              }
            ),
            (result: PaginationDTO<CompanyDTO>) => {
              /* if (result !== null && result.content && result.content[0]) {
                 //this.uiService.showMessage(this.getErrorMessage(error), new I18nData('General.error'));
                 return this.uiService.showMessage(
                   'La empresa que desea cargar ya existe en la aplicación.',
                   'Aviso',
                   'errorStyle'
                 );
               } else {*/
              this.companyService.dto2ViewModel(newCompany);
              this.openWindowCompany(newCompany, true);
              //}
            }
          );
        }
      }),
      catchError((error: any) => {
        this.plycaErrorHandler.showServerError(error);
        return throwError(error);
      })
    )
    );
  }

  load(searchButton = false) {
    this.waitService.startWaiting();
    this.editing = true;

    //this.companyList = [];
    //this.pageInfo.number = 0;
    if (searchButton) {
      this.pageInfo.number = 0;
    }
    //Busqueda de empresas
    this.subscribe(this.plycaService
      .query<CompanyDTO>(
        this.configuration.COMPANY_SERVICE_URL,
        this.getParams()
      ),
      (param: PaginationDTO<CompanyDTO>) => {
        if (param && param.content) {
          this.pageInfo.totalElements = param.page.totalElements;


          this.companyList = param.content;
        } else {
          this.companyList = [];
        }

        /* Napa para buscar con or en query */
        /* Si se ha especificado filtro por Razon social */
        /* Realizamos la búsqueda también por nombre comercial bajo el mismo filtro */
        /* Se requieren dos búsquedas ya que actualmente las apis nopermiten filtro con or */
        if (this.filters.name) {
          this.subscribe(this.plycaService
            .query<CompanyDTO>(
              this.configuration.COMPANY_SERVICE_URL,
              this.getParamsComercialName()
            ),
            (param: PaginationDTO<CompanyDTO>) => {
              if (param && param.content) {
                this.pageInfo.totalElements = param.page.totalElements;
                param.content.forEach(el => {
                  this.companyList = this.arrayCompanyRemove(this.companyList, el.identifier);
                });
                param.content.forEach(el => {
                  this.companyList.push(el);
                });
              }
            });
        }
      });
    this.loaded = true;
    this.waitService.cancelWaiting();
  }



  arrayCompanyRemove(companyListRemove: CompanyDTO[], value: string): CompanyDTO[] {
    companyListRemove = companyListRemove.filter(function (ele) {
      return ele.identifier != value;
    });
    return companyListRemove;
  }


  editMode() {
    this.editing = true;
  }

  addCompanyLeganes() {
    let parametersURL: ActionParameterDefinitionDTO[] = [];

    let completedResult = true;
    let autoSearch = false;
    //let searchConfig = new SearchConfig();
    //searchConfig.multiSelection = true;
    //searchConfig.actionCfg = {
    //rowFn: this.rowFnImportar.bind(this),
    //postExecuteFn: this.postExcuteFnImportar.bind(this)
    //};

    let contextSearch = new SearchSettingDTOModal(
      'LEGANESIntegrationCompanySearch',
      autoSearch,
      parametersURL,
      completedResult
      //,searchConfig
    );
    let config: DynamicDialogConfig = {
      header: '',
      width: '70%',
      style: { overflow: 'scroll', 'max-height': '80%' }
    };
    config['context'] = contextSearch;

    const ref = this.dialogService.open(searchGenericComponent, config);


    this.subscribe(ref.onClose.pipe(
      tap((newCompany: CompanyDTO) => {
        this.subscribe(
          this.plycaService.query<CompanyDTO>(
            this.configuration.COMPANY_SERVICE_URL,
            {
              taxIdentifier: newCompany.taxIdentifier
            }
          ),
          (result: PaginationDTO<CompanyDTO>) => {

            /* if (result !== null && result.content && result.content[0]) {
               //this.uiService.showMessage(this.getErrorMessage(error), new I18nData('General.error'));
               return this.uiService.showMessage(
                 'La empresa que desea cargar ya existe en la aplicación.',
                 'Aviso',
                 'errorStyle'
               );
             }else {*/
            this.companyService.dto2ViewModel(newCompany);
            this.openWindowCompany(newCompany, true);
            //}
          }
        );
      }),
      catchError((error: any) => {
        this.plycaErrorHandler.showServerError(error);
        return throwError(error);
      })
    )
    );


    /* this.subscribe(ref.onClose,
       (newCompany: CompanyDTO) => {
         //this.load();

         this.companyService.dto2ViewModel(newCompany);
         this.openWindowCompany(newCompany, true);
       },
       (error) => {
         this.showErrors(error)
       }
     );*/

    /*this.subscribe(this.companyService.get(newCompany),
    response => {
      newCompany = response;
      this.companyService.dto2ViewModel(newCompany);
      this.openWindowCompany(newCompany, true);
    },
    err => {
      this.showErrors(err);
    }
  );*/
  }

  addCompany() {
    // this.openWindowCompany(new CompanyDTO(), true);
    let newCompany = new CompanyDTO();
    newCompany.identifier = 'new'
    this.subscribe(this.companyService.get(newCompany),
      response => {
        newCompany = response;
        this.companyService.dto2ViewModel(newCompany);
        this.openWindowCompany(newCompany, true);
      },
      err => {
        this.showErrors(err);
      }
    );
  }


  editCompany(row: CompanyDTO) {
    let company: CompanyDTO;
    this.subscribe(this.companyService.get(row),
      response => {
        company = response;
        this.companyService.dto2ViewModel(company);
        this.openWindowCompany(company, false);
      },
      err => {
        this.showErrors(err);
      }
    );

  }

  publicateRIL(row: CompanyDTO) {
    console.log('Publicando RIL...');
    let companyProject = new CompanyProjectDTO();
    companyProject.company = row;

    this.getRILFile(companyProject.company);

    this.subscribe(this.plycaService.republicateCompanyProject(this.companyProjectSelected).pipe(
      finalize(() => {
        this.uiService.showMessage(this.translate.instant('Se ha lanzado el trámite para republicar el expediente RIL'), 'Info', 'successStyle');

      })
    ));

  }

  createRIL(row: CompanyDTO) {


    let companyProject = new CompanyProjectDTO();
    companyProject.company = row;

    this.uiService.showConfirmMessage({
      message: this.translate.instant('CompanyList.ril.createConfirm'),
      header: this.translate.instant('General.confirm.text'),
      icon: 'pi pi-exclamation-triangle',
      //key: 'confirm1',
      accept: () => {
        this.waitService.startWaiting();
        this.subscribe(this.plycaService.validate(this.configuration.COMPANYPROJECT_SERVICE_URL, 'Insert', companyProject)
          //this.subscribe(this.validate(false, dto)
          , result => {
            if (result.result === ResultTypeDTO.ERROR) {
              this.showErrors(result.errors);
              alert('No se ha podido registrar el expediente RIL');
            } else if (result.result === ResultTypeDTO.OK) {
              this.insertRIL(companyProject);
            } else {
              // Error de validación FATAL
              this.waitService.cancelWaiting();
            }
          },
          err => {
            this.showErrors(err);
          }
        )
      },
      reject: () => {
        console.log('ELIMINACIÓN CANCELADA');
        this.waitService.cancelWaiting();
      },
    });




    //this.router.navigate(['/companyProjects/'], { queryParams: { company: row, } });
    /*let config: DynamicDialogConfig = {
      header: this.translate.instant('CompanyAdmin.title'),
      width: '80%',
      styleClass: 'formEdition'

    };

    //config['item'] = new ViewDTOModal(row, 'companyDetailISettings.json');
    //config['esAltaEmpresa'] = esAlta;
    let dto = new CompanyProjectDTO();
    dto.company = row;

    config['dto'] = dto;
    const ref = this.dialogService.open(
      CompanyProjectComponent,
      config
    );


    this.subscribe(ref.onClose,
      result => {

        this.load();

      });*/

  }

  insertRIL(dto: CompanyProjectDTO) {

    console.log('Grabando RIL...');
    this.waitService.startWaiting();
    this.subscribe(this.plycaService.insert<CompanyProjectDTO>(this.configuration.COMPANYPROJECT_SERVICE_URL, dto).pipe(

      finalize(() => {

        this.waitService.cancelWaiting();
      })
    ),
      response => {
        console.log('INSERT AWARD OK', response);
        this.waitService.startWaiting();
        this.load();
        //this.router.navigate(['companyList'], {
        //});
        this.waitService.cancelWaiting();
      },
      error => {
        console.log('INSERT AWARD ERROR', error);
        alert('No se ha podido registrar el expediente RIL');
      }
    );
  }

  openWindowCompany(row: CompanyDTO, esAlta: boolean) {

    let config: DynamicDialogConfig = {
      header: this.translate.instant('CompanyAdmin.title'),
      width: '70%',
      style: { overflow: 'scroll' },
      styleClass: 'formEdition'

    };

    config['item'] = new ViewDTOModal(row, 'companyDetailISettings.json');
    config['esAltaEmpresa'] = esAlta;

    const ref = this.dialogService.open(
      CompanyAdminComponent,
      config
    );


    this.subscribe(ref.onClose,
      result => {

        this.load();

      });
  }


  removeCompany(row: CompanyDTO) {
    let integration = this.properties['SincronizacionTerceros_Activo'] && this.properties['SincronizacionTerceros_FraMtoEmpresa_PublicarAlEliminarTercero_Activo'];
    this.uiService.showConfirmMessage({
      message: this.translate.instant('General.confirm.action.delete'),
      header: this.translate.instant('General.confirm.text'),
      icon: 'pi pi-exclamation-triangle',
      //key: 'confirm1',
      accept: () => {
        if (integration) {
          this.confirm2(row);
        } else {
          this.callRemoveCompanyService(row);
        }
      },
      reject: () => {
        console.log('ELIMINACIÓN CANCELADA');
      },
    });
  }

  confirm2(row: CompanyDTO) {
    this.uiService.showConfirmMessage({
      message: '¿Desea enviar los datos de la empresa al Sistema Externo?',
      header: this.translate.instant('General.confirm.text'),
      icon: 'pi pi-exclamation-triangle',
      key: 'confirm2',
      accept: () => {
        row.synchronize = true; // Si hay integración de terceros se sincronizará la empresa con el sistema externo
        this.callRemoveCompanyService(row);
      },
      reject: () => {
        this.callRemoveCompanyService(row);
      }
    })
  }

  private callRemoveCompanyService(row: CompanyDTO) {
    this.subscribe(this.companyService.remove(row),
      response => {
        this.load();
      },
      err => {
        this.showErrors(err);
      }
    );
  }

  showErrors(err: any) {
    this.plycaErrorHandler.showServerError(err);
  }

  isEditing(): boolean {
    return this.editing;
  }

  isLoaded() {
    return this.loaded;
  }


  public getFieldConfig(name: string): FieldConfig {
    let config = new FieldConfig();
    config.fieldStyle = 'col-12';
    config.jsonField = name;
    config.type = 'TEXT';
    if (name === this.PARAM_TAXIDENTIFIER) {
      config.description = this.translate.instant('CompanyList.identifier');
    } else if (name === this.PARAM_NAME) {
      config.description = this.translate.instant('CompanyList.name');
    }
    return config;
  }

  public getFieldConfigYesNo(name: string): FieldConfig {
    let config = new FieldConfig();
    config.fieldStyle = 'col-12';
    config.jsonField = name;
    config.type = 'YES_NO';
    if (name === this.PARAM_RIL) {
      config.description = this.translate.instant('CompanyList.ril.filter');
    }
    return config;
  }


  getParamsComercialName() {
    let params: any = this.getParams();
    if (this.filters.name) {
      delete params.name;
      params.commercialName = this.filters.name;
    }
    return params;
  }

  getParams() {

    let params: any = {};

    params.expand = 'expansionSet:CLIENTE_WEB';

    if (this.filters.taxIdentifier) {
      params.taxIdentifier = this.filters.taxIdentifier;
    }

    if (this.filters.name) {
      params.name = this.filters.name;
    }
    if (this.filters.ril !== null && this.filters.ril !== undefined) {
      params.hasRilFile = this.filters.ril;
    }


    params.size = this.pageInfo.size;
    params.page = this.pageInfo.number;


    return params;

  }

  public clear() {
    this.search = '';
  }

  public getCompanyMenuItem(company: CompanyDTO): MenuItem[] {
    let items: MenuItem[] = [];
    //let mn1: MenuItem = {};
    let mn1 = {} as MenuItem;
    this.subscribe(
      this.translate.get('General.edit'),
      (res: string) => {
        mn1.label = res;
      }
    );
    mn1.icon = 'fas fa-pencil-alt';
    mn1.disabled = !this.userCanEdit;
    mn1.command = (event: Event) => {
      this.editCompany(company);
    };
    items.push(mn1);


    if (this.userCanEditRIL) {
      let mn3 = {} as MenuItem;
      let mn4 = {} as MenuItem;

      if (!company.hasRilFile) {
        this.subscribe(
          this.translate.get('CompanyList.ril.create'),
          (res: string) => {
            mn3.label = res;
          }
        );
        mn3.icon = 'fa fa-lg fa-archive';
        mn3.disabled = !this.userCanEditRIL
        mn3.command = (event: Event) => {
          this.createRIL(company);
        };
        items.push(mn3);





      } else {
        this.subscribe(
          this.translate.get('CompanyList.ril.view'),
          (res: string) => {
            mn3.label = res;
          }
        );
        mn3.icon = 'fa fa-lg fa-archive';
        mn3.disabled = !this.userCanEditRIL
        mn3.command = (event: Event) => {
          this.openRilFile(company);
        };
        items.push(mn3);

        this.subscribe(
          this.translate.get('CompanyList.ril.publicate'),
          (res: string) => {
            mn4.label = res;
          }
        );
        mn4.icon = 'fa fa-lg fa-archive';
        mn4.disabled = !this.userCanEditRIL
        mn4.command = (event: Event) => {
          this.publicateRIL(company);
        };
        items.push(mn4);
      }
    }


    let mn2 = {} as MenuItem;
    this.subscribe(
      this.translate.get('General.delete'),
      (res: string) => {
        mn2.label = res;
      }
    );
    mn2.icon = 'fa fa-trash text';
    mn2.disabled = !this.userCanEdit;
    mn2.command = (event: Event) => {
      this.removeCompany(company);
    };
    items.push(mn2);

    return items;
  }

  public getRILFile(editCompany: CompanyDTO) {
    let resultado: CompanyProjectDTO;
    if (editCompany && editCompany.identifier) {
      this.plycaService.query<CompanyProjectDTO>(
        this.configuration.COMPANYPROJECT_SERVICE_URL + '?',
        {
          companyId: editCompany.identifier
        }
      ).pipe(finalize(() => this.waitService.cancelWaiting()))
        .subscribe(result => {
          if (result) {
            if (result.content[0]) {
              this.companyProjectSelected = result.content[0];
            }
          }
        });
    }
    return resultado;
  }

  public hasRILFile(editCompany: CompanyDTO) {
    let resultado = false;
    if (editCompany && editCompany.identifier) {
      this.plycaService.query<CompanyProjectDTO>(
        this.configuration.COMPANYPROJECT_SERVICE_URL + '?',
        {
          companyId: editCompany.identifier
        }
      ).pipe(finalize(() => this.waitService.cancelWaiting()))
        .subscribe(result => {
          if (result) {
            if (result.content[0]) {
              resultado = true;
            }
          } else {
            resultado = false;
          }
        });
    }
    return resultado;
  }

  public openRilFile(editCompany: CompanyDTO) {
    let companyProject;
    if (editCompany && editCompany.identifier) {
      this.plycaService.query<CompanyProjectDTO>(
        this.configuration.COMPANYPROJECT_SERVICE_URL + '?',
        {
          companyId: editCompany.identifier
        }
      ).pipe(finalize(() => this.waitService.cancelWaiting()))
        .subscribe(result => {
          if (result) {
            companyProject = result.content[0];
            if (companyProject) {
              this.router.navigate(['/dossierInfo/' + companyProject.identifier], { queryParams: { component: 'DOCUMENTS', } });
              //this.closeWindow(true);
            }
          } else {
            //this.uiService.showMessage('El usuario no tiene permisos para visualizar la información del expediente RIL.', 'Error', 'errorStyle');
            this.uiService.showMessage(this.translate.instant('CompanyList.ril.errorPermisos'), 'Error', 'errorStyle');

            //this.closeWindow(true);
          }
        });
    }

  }
}
